import React, { useRef, useEffect } from 'react';
import styles from './GlitchRainText.module.css';

/**
 * DatamoshText - 데이타모싱 효과
 * 텍스트가 비디오 압축 오류처럼 녹아서 뭉개지고 흔적이 남는 효과
 */
const GlitchRainText = ({ text = 'GNEGNEGNE', theme }) => {
    const canvasRef = useRef(null);
    const containerRef = useRef(null);
    const isDark = theme?.backgroundColor === '#151515';
    const textColor = isDark ? '#00ff00' : '#333333';

    useEffect(() => {
        const canvas = canvasRef.current;
        const container = containerRef.current;
        if (!canvas || !container) return;

        // 컨테이너 너비에 맞게 Canvas 크기 설정
        const containerWidth = container.offsetWidth;
        canvas.width = containerWidth;
        canvas.height = 80;

        const ctx = canvas.getContext('2d');
        const width = canvas.width;
        const height = canvas.height;

        // 초기 배경색 설정 (Warm Ivory)
        const bgColor = isDark ? '#151515' : '#fffdf8';
        ctx.fillStyle = bgColor;
        ctx.fillRect(0, 0, width, height);

        let animationId;
        // eslint-disable-next-line no-unused-vars
        let offset = 0;

        // 잔상 효과를 위한 복사본 저장 - 현재 미사용
        // eslint-disable-next-line no-unused-vars
        let prevFrameData = null;

        const animate = () => {
            // 데이타모싱: 이전 프레임을 완전히 지우지 않고 살짝만 페이드
            // 이것이 핵심 - 잔상이 남아서 모션 블러/스미어 느낌
            ctx.fillStyle = isDark ? 'rgba(21, 21, 21, 0.15)' : 'rgba(255, 253, 248, 0.15)';
            ctx.fillRect(0, 0, width, height);

            // 가끔 프레임 스킵 (데이타모싱의 핵심 효과)
            const skipFrame = Math.random() < 0.1;

            if (!skipFrame) {
                // 메인 텍스트 그리기
                ctx.fillStyle = textColor;
                ctx.font = 'bold 32px "Courier New", monospace';
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';

                // 약간의 위치 변동 (데이타모싱 떨림)
                const jitterX = (Math.random() - 0.5) * 3;
                const jitterY = (Math.random() - 0.5) * 2;

                ctx.fillText(text, width / 2 + jitterX, height / 2 + jitterY);

                // 가끔 블록 복사 (데이타모싱의 핵심)
                if (Math.random() < 0.08) {
                    const blockSize = 10 + Math.random() * 30;
                    const srcX = Math.random() * (width - blockSize);
                    const srcY = Math.random() * (height - blockSize);
                    const dstX = srcX + (Math.random() - 0.5) * 40;
                    const dstY = srcY + (Math.random() - 0.5) * 20;

                    try {
                        const imageData = ctx.getImageData(srcX, srcY, blockSize, blockSize);
                        ctx.putImageData(imageData, dstX, dstY);
                    } catch (e) {
                        // 무시
                    }
                }

                // 가끔 수평 스트레치 (압축 아티팩트)
                if (Math.random() < 0.05) {
                    const stretchY = Math.random() * height;
                    const stretchHeight = 2 + Math.random() * 8;
                    try {
                        const lineData = ctx.getImageData(0, stretchY, width, stretchHeight);
                        ctx.putImageData(lineData, 0, stretchY + (Math.random() - 0.5) * 10);
                    } catch (e) {
                        // 무시
                    }
                }
            }

            offset += 0.02;
            animationId = requestAnimationFrame(animate);
        };

        animate();

        return () => {
            if (animationId) {
                cancelAnimationFrame(animationId);
            }
        };
    }, [text, textColor, isDark]);

    return (
        <div className={styles.container} ref={containerRef}>
            <canvas
                ref={canvasRef}
                height={80}
                className={styles.canvas}
                style={{ width: '100%' }}
            />
        </div>
    );
};

export default GlitchRainText;
